module.exports = __webpack_public_path__ + "img/bf.90d57f77.svg";